// extracted by mini-css-extract-plugin
export var cardHeader = "_fi-1";
export var contentCard = "_fi-0";
export var headerActions = "_fi-3";
export var reorderHandle = "_fi-5";
export var titleArea = "_fi-2";
export var titleAreaWithHandle = "_fi-4";